import React, {Component} from 'react';
import {BrowserRouter as Router, Redirect, Route, Switch} from "react-router-dom";
import {combineReducers, createStore} from 'redux';
import {sessionReducer, sessionService} from 'redux-react-session';
import {positions, Provider} from "react-alert";
import AlertTemplate from "react-alert-template-basic";
import {getUser} from "./auth/Auth";
import ScrollToTop from './components/ScrollToTop';
import Header from "./views/Header";
import Home from "./views/Home";
import Login from "./views/Login";
import SignUp from "./views/SignUp";
import Partners from "./views/Partners";
import Categories from "./views/Categories";
import ContactUs from "./views/ContactUs";
import AboutUs from "./views/AboutUs";
import Delivery from "./views/Delivery";
import Account from "./views/Account";
import AccountSettings from "./views/AccountSettings";
import ManageUsers from "./views/ManageUsers";
import ManageOrders from "./views/ManageOrders";
import ManageStore from "./views/ManageStore";
import ManagePartners from "./views/ManagePartners";
import Category from "./views/Category";
import Checkout from "./views/Checkout";
import Product from "./views/Product";
import SearchResult from "./views/SearchResult";
import ForgotPassword from "./views/ForgotPassword";
import Footer from "./views/Footer";
import './App.css';

class App extends Component {
    constructor(props) {
        super(props);
        const reducer = combineReducers({
            session: sessionReducer
        });
        const store = createStore(reducer);
        sessionService.initSessionService(store);

        const options = {
            timeout: 5000,
            position: positions.MIDDLE_RIGHT
        };

        this.state = {options: options, user: undefined};
    }

    componentDidMount() {
        getUser().then((data) => {
            this.setState({user: data});
        }).catch(() => {
            this.setState({user: null});
        });
    }

    render() {
        const {options, user} = this.state;
        if (user !== undefined) {
            return (
                <Router>
                    <ScrollToTop>
                        <div id="header">
                            <Header/>
                        </div>
                        <div id="body">
                            <Provider template={AlertTemplate} {...options} id="body">
                                <Switch>
                                    <Route exact path="/">
                                        <Home/>
                                    </Route>
                                    <Route exact path="/login">
                                        <Login/>
                                    </Route>
                                    <Route exact path="/signup">
                                        <SignUp/>
                                    </Route>
                                    <Route exact path="/partners">
                                        <Partners/>
                                    </Route>
                                    <Route exact path="/categories">
                                        <Categories/>
                                    </Route>
                                    <Route exact path="/contact-us">
                                        <ContactUs/>
                                    </Route>
                                    <Route exact path="/about-us">
                                        <AboutUs/>
                                    </Route>
                                    <Route exact path="/delivery">
                                        <Delivery/>
                                    </Route>
                                    <Route exact path="/checkout">
                                        <Checkout/>
                                    </Route>
                                    <Route exact path="/forgot-password">
                                        <ForgotPassword/>
                                    </Route>
                                    <Route exact path="/search-results">
                                        <SearchResult/>
                                    </Route>
                                    <Route exact path="/category/:categoryName">
                                        <Category/>
                                    </Route>
                                    <Route exact path="/partner/:partnerName">
                                        <Category/>
                                    </Route>
                                    <Route exact path="/product/:productId">
                                        <Product/>
                                    </Route>
                                    <Route exact path="/account">
                                        {user ? <Account/> : <Redirect to="/login"/>}
                                    </Route>
                                    <Route exact path="/account-settings">
                                        {user ? <AccountSettings/> : <Redirect to="/login"/>}
                                    </Route>
                                    <Route exact path="/manage-users">
                                        {user && user.role_id === 3 ? <ManageUsers/> : <Redirect to="/login"/>}
                                    </Route>
                                    <Route exact path="/manage-orders">
                                        {user && (user.role_id === 2 || user.role_id === 3) ?
                                            <ManageOrders/> : <Redirect to="/login"/>}
                                    </Route>
                                    <Route exact path="/manage-store">
                                        {user && user.role_id === 2 ? <ManageStore/> : <Redirect to="/login"/>}
                                    </Route>
                                    <Route exact path="/manage-partners">
                                        {user && user.role_id === 3 ? <ManagePartners/> : <Redirect to="/login"/>}
                                    </Route>
                                    <Route path="*">
                                        <Redirect to="/"/>
                                    </Route>
                                </Switch>
                            </Provider>
                        </div>
                        <div id="footer">
                            <Footer/>
                        </div>
                    </ScrollToTop>
                </Router>
            );
        } else {
            return null;
        }
    }
}

export default App;
